import { useMutation } from '@apollo/client';

import { CreateTargetInput } from '../../apollo/__generated__/graphql';
import { CREATE_TARGET } from '../graphql/mutation/createTargetMutation.graphql';

export const useCreateTargetMutation = () => {
  const [mutate] = useMutation(CREATE_TARGET);

  const createTarget = (createTargetInput: CreateTargetInput) => {
    mutate({
      variables: {
        createTargetInput,
      },
    });
  };

  return { createTarget };
};
